"use client";

import { useMenuContext } from "../__chunks/SJPAIJOW.js";
import "../__chunks/QVEJ36PB.js";
import { usePopoverArrow } from "../__chunks/UPTSIFGR.js";
import "../__chunks/QFL5V2DO.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/DPAO6G5R.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-arrow.tsx
var TagName = "div";
var useMenuArrow = createHook(function useMenuArrow2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useMenuContext();
  store = store || context;
  return usePopoverArrow(__spreadValues({
    store: store
  }, props));
});
var MenuArrow = forwardRef(function MenuArrow2(props) {
  var htmlProps = useMenuArrow(props);
  return createElement(TagName, htmlProps);
});
export { MenuArrow, useMenuArrow };